import { requestWithToken, requestWithoutToken } from "../helper/helper";

const fetchGovtScheme = async (pageNo, pageSize) => {
    try {
        const response = await requestWithToken(
            "GET",
            `/govtScheme/list?pageNo=${pageNo}&pageSize=${pageSize}`
        );

        return response.data;
    } catch (err) {
        return err.response.data;
    }
};

const AddGovtScheme = async (payload) => {
    try {
        const response = await requestWithToken("POST", `/govtScheme`, payload);
        return response.data;
    } catch (err) {
        return err.response.data;
    }
};
const deleteScheme = async (id) => {
    try {
        const response = await requestWithToken("DELETE", `/govtScheme/${id}`);
        return response;
    } catch (err) {
        return err.response.data;
    }
};
const updateGovtScheme = async (id, payload) => {
    try {
        const response = await requestWithToken("PUT", `/govtScheme/${id}`, payload);

        return response.data;
    } catch (err) {
        return err.response.data;
    }
};
export { fetchGovtScheme, AddGovtScheme, updateGovtScheme, deleteScheme }